
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor-crema-facility/[parlor]/[crema]/[facility]",
      function () {
        return require("private-next-pages/parlor-crema-facility/[parlor]/[crema]/[facility].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor-crema-facility/[parlor]/[crema]/[facility]"])
      });
    }
  